// Third-party imports
import Velocity from 'velocity-animate';
import 'velocity-animate/velocity.ui';

const FADE_SPEED = 200;

export function initialize(global) {

    init_open_memoriam_preview_handler(global);
    init_close_memoriam_preview_handler(global);
    init_toggle_message(global);
}

function init_toggle_message(global) {
    let add_message = global.document.getElementById('add_message');
    let donor_message = global.document.getElementById('donor_message');
    var inMemoryOf = global.document.getElementById('inMemoryOf').value;
    add_message.addEventListener('click', () => {
        if (add_message.classList.contains('generic_message')) {
            add_message.innerHTML = "Click this to add a personal message";
            add_message.classList.remove('generic_message');
            add_message.classList.add('personal_message');
            donor_message.value = generic_message(inMemoryOf);
        } else {
            add_message.innerHTML = "Click this to add a generic message";
            add_message.classList.remove('personal_message');
            add_message.classList.add('generic_message');
            donor_message.value = "";
            donor_message.focus();
        }
    });
}

function generic_message(deceased_name) {
    let generic_message = `Please accept my sincere condolences for your recent loss.\r\n\r\n I have made a donation to World Vision Canada to help create lasting change in the lives of the world's most vulnerable children and families.\r\n\r\nThinking of you during this difficult time.\r\n\r\nMay God's arms of love and compassion continue to support you in this difficult time.`
    return generic_message;
}

function init_open_memoriam_preview_handler(global) {
    let all_modal_trigger = global.document.querySelectorAll('.modal-trigger');
    if (all_modal_trigger.length === 0) {
        return;
    }
    for (let modal_trigger of all_modal_trigger) {
        modal_trigger.addEventListener('click', event => {
            event.preventDefault();
            let modal = document.querySelector('.js-previewEmailMemoriam-hook .modal');
            open_memoriam_modal(global, modal);
        });
    }
}

function open_memoriam_modal(global, modal) {
    modal.classList.add('modal--active');
    let overlay = modal.querySelector('.modal-overlay');
    Velocity(overlay, 'fadeIn', { duration: FADE_SPEED });
    global.document.querySelector('body').classList.add('u-freezeScroll');
    let memoriamEmailPreview = modal.querySelector('.js-memoriamEmailPreview-hook');
    memoriamEmailPreview.classList.remove('u-hide');
    eCardPreviewUserMessageInitializer(global);
}

function init_close_memoriam_preview_handler(global) {
    let all_modal_close = global.document.querySelectorAll('.modal-close');
    if (all_modal_close.length === 0) {
        return;
    }
    for (let modal_close of all_modal_close) {
        modal_close.addEventListener('click', event => {
            event.preventDefault();
            let modal = document.querySelector('.js-previewEmailMemoriam-hook .modal');
            close_memoriam_modal(global, modal);
        });
    }

}

function close_memoriam_modal(global, modal) {
    modal.classList.remove('modal--active');
    let overlay = modal.querySelector('.modal-overlay');
    Velocity(overlay, 'fadeOut', { duration: FADE_SPEED });
    global.document.querySelector('body').classList.remove('u-freezeScroll');
    let memoriamEmailPreview = modal.querySelector('.js-memoriamEmailPreview-hook');
    memoriamEmailPreview.classList.add('u-hide');
}

function eCardPreviewUserMessageInitializer(global) {
    let inMemoryOf = global.document.getElementById('inMemoryOf').value;
    let deceased_name = global.document.getElementById('deceased_name');
    deceased_name.innerHTML = inMemoryOf;
    var sender_first_name = global.document.getElementById("sender_first_name").value;;
    var sender_last_name = global.document.getElementById("sender_last_name").value;
    let sympathyPreviewSender = global.document.querySelectorAll('.sympathyPreviewSender');
    for (let sender of sympathyPreviewSender) {
        sender.innerHTML = sender_first_name + " " + sender_last_name;
    }

    var title = global.document.getElementById("title");
    var title_text = title.options[title.selectedIndex].text;
    let sympathyPreviewTitle = document.querySelector('.sympathyPreviewTitle');
    sympathyPreviewTitle.innerHTML = title_text;

    let recipient_firstname = global.document.getElementById('firstName').value;
    let sympathyPreviewFirstName = document.querySelector('.sympathyPreviewFirstName');
    sympathyPreviewFirstName.innerHTML = recipient_firstname;

    let recipient_lastname = global.document.getElementById('lastName').value;
    let sympathyPreviewLastName = document.querySelector('.sympathyPreviewLastName');
    sympathyPreviewLastName.innerHTML = recipient_lastname;

    let donor_message = global.document.getElementById('donor_message').value;
    let insert_msg = document.querySelector('.sympathyPreviewSendMessage');
    insert_msg.innerHTML = donor_message.replace(/(\r\n|\r|\n)/g, '<br>');
}



